import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import defaultLanguages from '../../utils/languages';

// `languages` / `defaultLanguage` are optional: Radio lists es first and opens on es,
// because its Spanish title is the required one. Everything else keeps en/es/ca/pt and en.
const LanguageTabsForms = ({
  children, activeTabStyle, width, tabStyle, languages, defaultLanguage,
}) => {
  const [activeLanguage, setActiveLanguage] = useState(defaultLanguage);

  const handlerActiveLanguage = (e) => {
    const { name } = e.target.dataset;
    setActiveLanguage(name);
  };

  const tabs = languages.map(lang => (
    <span
      key={lang}
      className={`${activeLanguage === lang ? `${activeTabStyle} pl-2 pl-7 flex items-center cursor-pointer font-semibold text-xs rounded-t uppercase` : `${tabStyle} tab pl-2 pl-7 flex items-center cursor-pointer font-semibold text-xs rounded-t uppercase`}`}
      data-name={lang}
      onClick={handlerActiveLanguage}
    >
      {lang}
    </span>
  ));

  return (
    <div className={`text-white language-tabs ${width}`}>
      <div className="flex">
        {tabs}
      </div>
      {children(activeLanguage, languages)}
    </div>
  );
};

LanguageTabsForms.propTypes = {
  children: PropTypes.func.isRequired,
  activeTabStyle: PropTypes.string,
  tabStyle: PropTypes.string,
  width: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.string),
  defaultLanguage: PropTypes.string,
};

LanguageTabsForms.defaultProps = {
  activeTabStyle: '',
  tabStyle: '',
  width: '',
  languages: defaultLanguages,
  defaultLanguage: 'en',
};

export default LanguageTabsForms;
